import { Col, Modal, Row, Spin } from "antd";
import React, {
  useState,
  useCallback,
  useRef,
  useMemo,
  useEffect,
} from "react";
import styled from "styled-components";
import AnswerForm from "../Template/AnswerForm";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { RightOutlined } from "@ant-design/icons";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import dayjs from "dayjs";
import SuccessDeclinePopup from "reusableComponent/Popup/SuccessDeclinePopup";
import UserFloatingButton from "../UserFloatingButton";
import ViewKpi from "./ViewKpi";

const AttendWrap = styled.div`
  position: relative;
  height: calc(100vh - 150px);
  .scroll-container {
    overflow: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .scroll-container::-webkit-scrollbar {
    display: none;
  }
`;

const StyledModal = styled(Modal)`
  .ant-modal-header {
    border-bottom: none;
    padding-top: 20px;
  }
  .ant-modal-title {
    font-weight: bold;
    font-weight: 1.2rem;
  }
  .ant-modal-body {
    padding-top: 0px;
  }
  .ant-modal-footer {
    display: none;
  }
  .ant-form-item-label {
    font-weight: 500;
  }
  .ant-picker {
    width: 100%;
  }
  .ant-picker-input > input[disabled],
  .ant-select-disabled.ant-select:not(.ant-select-customize-input)
    .ant-select-selector,
  .ant-input[disabled] {
    color: rgba(0, 0, 0, 1);
  }
`;

const prefixIds = (questions = [], prefix) =>
  questions.map((q) => ({ ...q, id: `${prefix}__${q.id}` }));

const isQuestionAnswered = (question) => {
  if (question.formType === "CHECKBOX") {
    return question.options?.some((opt) => opt.isChecked === true);
  }
  return (
    question.answer !== undefined &&
    question.answer !== null &&
    question.answer !== ""
  );
};

const Attend = () => {
  const location = useLocation();
  const history = useHistory();
  const KpiData = location.state?.dataList;
  const isView = location.state?.isview || false;
  const [isViewKpi, setIsViewKpi] = useState(false);

  console.log("KpiData-->", KpiData);
  const [dataList, setDataList] = useState([]);
  console.log("dataList-->", dataList);
  const [loading, setLoading] = useState(false);

  const introQuestions = useMemo(
    () => prefixIds(dataList?.introductorysection || [], "intro"),
    [dataList]
  );
  const mainQuestions = useMemo(
    () => prefixIds(dataList?.mainquestionnairesection || [], "main"),
    [dataList]
  );
  const remarkQuestions = useMemo(
    () => prefixIds(dataList?.remarkssection || [], "remark"),
    [dataList]
  );

  const [introductoryDetail, setIntroductoryDetail] = useState(introQuestions);

  console.log("introductoryDetail-->", introductoryDetail);
  const [mainSectionDetail, setMainSectionDetail] = useState(mainQuestions);
  const [remarkSectionDetail, setRemarkSectionDetail] =
    useState(remarkQuestions);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [popupOpen, setPopupOpen] = useState(false);

  const introSelectedItem = useRef({
    deleteStatus: false,
    questions: introQuestions,
  });
  const mainSelectedItem = useRef({
    deleteStatus: false,
    questions: mainQuestions,
  });
  const remarkSelectedItem = useRef({
    deleteStatus: false,
    questions: remarkQuestions,
  });

  const handleSetIntroductory = useCallback(
    (val) => setIntroductoryDetail(val),
    []
  );
  const handleSetMain = useCallback((val) => setMainSectionDetail(val), []);
  const handleSetRemark = useCallback((val) => setRemarkSectionDetail(val), []);

  const stripPrefix = (questions = []) =>
    questions.map((q) => ({
      ...q,
      id: q.id.includes("__") ? q.id.split("__")[1] : q.id,
    }));

  const handleClearError = useCallback((questionId) => {
    setValidationErrors((prev) => {
      if (!prev[questionId]) return prev; // nothing to clear
      const updated = { ...prev };
      delete updated[questionId];
      return updated;
    });
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data, code } = await CALL_API(
        `performance/attendappraisal/${KpiData?.appraiseeuserid}?kpiid=${KpiData?.id}`,
        "get"
      );
      console.log("code-->", code);
      if (code === STATUS_CODE.SUCCESS) {
        console.log("data12-->", data);
        setDataList(data[0]);
        setLoading(false);
      } else {
        throw new Error(`Failed to fetch data: ${code}`);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const onSubmitClick = async () => {
    const errors = {};
    [...mainSectionDetail]
      .filter((q) => q.question)
      .forEach((q) => {
        if (!isQuestionAnswered(q)) {
          errors[q.id] = true;
        }
      });

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);

      // Scroll to first unanswered question
      const firstErrorId = Object.keys(errors)[0];
      const el = document.getElementById(`question-${firstErrorId}`);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    setValidationErrors({});
    setSubmitLoading(true);

    const payload = {
      attendedon: dayjs().format("YYYY-MM-DD") || "",
      mainquestionnairesection: stripPrefix(mainSectionDetail) || [],
      introductorysection: stripPrefix(introductoryDetail) || [],
      remarkssection: stripPrefix(remarkSectionDetail) || [],
      attendstatus: "1",
    };

    console.log("payload-->", payload);
    const { code } = await CALL_API(
      `performance/attendappraisal/${KpiData?.id}`,
      "patch",
      payload
    );
    if (code === STATUS_CODE.SUCCESS) {
      setPopupOpen(true);
      setTimeout(() => {
        setPopupOpen(false);
        history.push("/performance", { id: "1" });
      }, 2000);
      setSubmitLoading(false);
    } else {
      setSubmitLoading(false);
    }
  };

  useEffect(() => {
    if (dataList?.introductorysection) {
      setIntroductoryDetail(prefixIds(dataList.introductorysection, "intro"));
      introSelectedItem.current.questions = prefixIds(
        dataList.introductorysection,
        "intro"
      );
    }
    if (dataList?.mainquestionnairesection) {
      setMainSectionDetail(
        prefixIds(dataList.mainquestionnairesection, "main")
      );
      mainSelectedItem.current.questions = prefixIds(
        dataList.mainquestionnairesection,
        "main"
      );
    }
    if (dataList?.remarkssection) {
      setRemarkSectionDetail(prefixIds(dataList.remarkssection, "remark"));
      remarkSelectedItem.current.questions = prefixIds(
        dataList.remarkssection,
        "remark"
      );
    }
  }, [dataList]);

  const footerStyle = {
    position: "sticky",
    bottom: -20,
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    padding: "10px",
    display: "flex",
    justifyContent: "end",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    margin: "0px -20px",
  };

  const ratingSummary = useMemo(() => {
    const ratingQuestions = mainSectionDetail.filter(
      (q) => q.formType === "RATING"
    );

    const totalStars = ratingQuestions.reduce(
      (sum, q) => sum + (q.starCount || 5),
      0
    );

    const totalValue = ratingQuestions.reduce(
      (sum, q) => sum + (Number(q.answer) || 0),
      0
    );

    const percentage = totalStars > 0 ? (totalValue / totalStars) * 100 : 0;

    return {
      name: "Self Score",
      totalStars,
      totalValue,
      percentage,
    };
  }, [mainSectionDetail]);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <AttendWrap>
      <StyledModal
        title={"My KPIs"}
        visible={isViewKpi}
        onCancel={() => {
          setIsViewKpi(false);
        }}
        width={800}
        footer={[]}
      >
        <ViewKpi dataList={dataList} />
      </StyledModal>

      <Spin spinning={loading}>
        <div
          className="scroll-container"
          style={{
            height: isView ? "calc(100vh - 150px)" : "calc(100vh - 200px)",
            overflowY: "scroll",
          }}
        >
          <div className="breadcrumb">
            <p
              className="lite-text p-0 m-0"
              style={{ cursor: "pointer" }}
              onClick={() => history.push("/performance", { id: "1" })}
            >
              Performance
            </p>
            &nbsp;
            <RightOutlined className="mt-1" />
            &nbsp;
            <p className="m-0 p-0">
              {isView ? "Viewing" : "Attending"} - {KpiData?.title}
            </p>
          </div>

          {introductoryDetail?.[0]?.question && (
            <>
              <h6>Indroductory Section</h6>
              <p className="lite-text">
                This section is used to collect basic details of appraisee and
                set context for the appraisal. This may include information like
                employee name, role, brief note etc...
              </p>
              <AnswerForm
                fullFormDetail={introductoryDetail}
                selectedItem={introSelectedItem.current}
                setAnswerResponse={handleSetIntroductory}
                validationErrors={validationErrors}
                onClearError={handleClearError}
                isView={isView}
              />
            </>
          )}

          {mainSectionDetail?.[0]?.question && (
            <>
              <h6 className="mt-5">
                Main Questionnaire Section
                <span className="text-danger">*</span>
              </h6>
              <p className="lite-text">
                This is the core performance evaluation section. Employees rate
                themselves and answer questions related to skills, goals, and
                performance. These questions will be automatically duplicated in
                the Appraiser form so that both self-ratings and reviewer
                ratings can be compared.
              </p>
              <AnswerForm
                fullFormDetail={mainSectionDetail}
                selectedItem={mainSelectedItem.current}
                setAnswerResponse={handleSetMain}
                validationErrors={validationErrors}
                onClearError={handleClearError}
                isView={isView}
                ratingSummary={ratingSummary}
              />
            </>
          )}

          {remarkSectionDetail?.[0]?.question && (
            <>
              <h6 className="mt-5">Remarks & Feedback Section</h6>
              <p className="lite-text">
                This section allows the employee to share additional comments,
                challenges, achievements, or expectations. It supports open
                feedback beyond ratings.
              </p>
              <AnswerForm
                fullFormDetail={remarkSectionDetail}
                selectedItem={remarkSelectedItem.current}
                setAnswerResponse={handleSetRemark}
                validationErrors={validationErrors}
                onClearError={handleClearError}
                isView={isView}
              />
            </>
          )}
        </div>
        <UserFloatingButton
          isViewKpi={isViewKpi}
          setIsViewKpi={setIsViewKpi}
          bottompossition={isView ? "20px" : "80px"}
        />
        {!isView && (
          <div style={footerStyle}>
            <ButtonOutlined
              className="border-0"
              onClick={() => history.push("/performance", { id: "1" })}
            >
              Cancel
            </ButtonOutlined>
            <ButtonFilled
              type="primary"
              loading={submitLoading}
              onClick={onSubmitClick}
            >
              Submit
            </ButtonFilled>
          </div>
        )}
        <SuccessDeclinePopup
          open={popupOpen}
          setOpen={setPopupOpen}
          type="success"
          message={"Submited"}
        />
      </Spin>
    </AttendWrap>
  );
};

export default Attend;
